export var ROOT_EL_ID = process.env.REACT_APP_ROOT_EL_ID || 'root';
export var BODY_ID = "figure-app-body";
export var NAV_ID = 'figure-app-nav';
export var ALL_UI_IDS = [BODY_ID, NAV_ID];